<template>
  <Card
    class="residential-account-card"
    :class="{ 'residential-account-card--disabled': !published }"
    :thumbnail="thumbnail"
    :tag="published ? 'router-link' : 'div'"
    :to="{ name: 'residential-account', params: { id: value.id } }"
  >
    <template v-if="!thumbnail" #header>
      <FontAwesomeIcon :icon="['fal', 'home']" size="4x" style="opacity: 0.4" />
    </template>
    <template #default>
      <div class="residential-account-card__name">
        <div>{{ $path('reference.name', value) }}</div>
      </div>
      <div class="residential-account-card__project">
        <div>{{ `${$tc('project', 1)}: ${$path('reference.project.name', value)}` }}</div>
      </div>
      <div class="residential-account-card__publishing">
        <div>{{ $t(published ? 'published' : 'unpublished') }}</div>
        <div
          class="residential-account-card__publishing-indicator"
          :class="['text--' + (published ? 'success' : 'error')]"
        ></div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  props: {
    value: Object,
  },
  computed: {
    published() {
      return this.value.status === 'published'
    },
    thumbnail() {
      return getCoverThumbnail(this.$path('value.reference.media.cover') || [])
    },
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.residential-account-card {
  .card__content {
    display: flex;
    flex-direction: column;
  }

  &--disabled {
    filter: opacity(0.5);
  }

  &__name {
    font-weight: bold;
  }
  &__project {
    font-size: 0.9em;
    opacity: 0.7;
    margin-bottom: 0.5em;
  }

  &__publishing {
    display: flex;
    align-items: center;
    color: css-alpha('dark', 0.5);
    font-size: 0.8em;
    margin-top: 3px;

    &-indicator {
      $size: 8px;
      width: $size;
      height: $size;
      margin-left: 0.5rem;
      border-radius: 50%;
      background-color: currentColor;
    }
  }
}
</style>
